import {fonts} from '../../theme/foundations/fonts'
import sizes from '../../theme/foundations/sizes'
import {pxToRem} from '../../utills/pxToRem'

export const storeShipmentButtonStyles = {
    '.radio': {
        display: 'flex',
        gap: pxToRem(32),
        '.chakra-radio__control[data-checked]': {
            background: 'none',
            backgroundColor: 'none',
            border: `${pxToRem(1)} solid black`
        },
        '.chakra-radio__control[data-checked]::before': {
            backgroundColor: 'black',
            margin: `${pxToRem(3)} auto`,
            height: pxToRem(8),
            width: pxToRem(8)
        },
        sapn: {
            margin: 0,
            display: 'flex',
            alignItems: 'center'
        },
        label: {
            alignItems: 'center',
            color: 'black',
            span: {
                fontSize: pxToRem(14),
                marginTop: 0,
                [`@media (min-width: ${sizes.container.md})`]: {
                    fontSize: pxToRem(16)
                }
            }
        },
        'span.chakra-radio__label': {
            marginLeft: pxToRem(10),
            lineHeight: 'normal',
            letterSpacing: pxToRem(1),
            [`@media (min-width: ${sizes.container.md})`]: {
                marginLeft: pxToRem(15)
            }
        },
        'span.chakra-radio__control': {
            border: `${pxToRem(1)} solid black`,
            height: pxToRem(12),
            width: pxToRem(12),
            [`@media (min-width: ${sizes.container.md})`]: {
                height: pxToRem(20),
                width: pxToRem(20)
            }
        }
    }
}

export const shipToMeTooltipStyle = {
    background: 'blackAlpha.650',
    color: 'white',
    borderRadius: '0',
    fontFamily: fonts.primary,
    fontSize: pxToRem(13),
    fontWeight: '400',
    letterSpacing: pxToRem(1)
}
